import React from 'react';

import './styles.scss';
import { useNavigate } from 'react-router';

const SideView = ({ textHeader, children, handleBack, fullContainer = false }) => {
    const navigate = useNavigate()

    function back() {
        if (handleBack != null)
            handleBack();
        else {
            navigate(-1)
        }
    }

    return (
        <div className="side-view">
            <div className="side-content col-10 col-sm-10 col-md-9 col-lg-7 col-xl-7">
                <h4 className="mb-3 uninter-sala-side-voltar">
                    <button className="uninter-btn-voltar-side-modal" onClick={() => back()}>Voltar</button>
                    {textHeader}
                </h4>
                <div className={`container ${fullContainer ? 'h-100' : 'h-75'}`}>
                    {children}

                    <div className="side-footer">
                        <hr className="col-12 mb-4" />
                        <button className="btn uninter-btn-secundario" tooltip="Página anterior" tooltip-position="left" type="button"
                            onClick={() => back()}>
                            <i className="fas fa-arrow-right"></i>
                            <span>Voltar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SideView;